import styled from "styled-components";

export const ApplyPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ApplyPageTable = styled.div`
  background-color: #edf1fc;
  padding: 40px;
  border-radius: 24px;
  gap: 20px;
  max-width: 1400px;
  margin: 40px auto;
  z-index: 10;
  width: 90%;
  height: 100%;
  background-image: url("/assets/bg.png");
`;

export const ApplyPageTitle = styled.h1`
  color: #17224d;
  margin-bottom: 30px;
  text-align: center;
`;

export const ApplyResultCard = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export const Label = styled.label`
  font-size: 16px;
  color: #17224d;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 100%;
  box-sizing: border-box;
  color: #17224d;
`;

export const Textarea = styled.textarea`
  padding: 10px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 100%;
  color: #17224d;
  height: 150px;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
`;

export const FileInput = styled.input`
  font-size: 16px;
  position: absolute; /* Make it off-screen */
  width: 1px;
  height: 1px;
  opacity: 0; /* Ensure it's invisible */
  pointer-events: none; /* Make sure it doesn't interfere with other elements */
`;

export const FileLabel = styled.label`
  padding: 12px 20px;
  font-size: 16px;
  color: white;
  background-color: #0066cc;
  border-radius: 8px;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 100%;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #004f8c;
  }
`;

export const SubmitButton = styled.button`
  padding: 12px 20px;
  font-size: 16px;
  color: white;
  background-color: #0066cc;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  font-family: "Inter", sans-serif;

  &:hover {
    background-color: #004f8c;
  }
`;

export const ApplyResultContent = styled.p`
  font-size: 16px;
  color: #17224d;
  line-height: 1.5;
`;

export const ApplyResultLink = styled.a`
  font-size: 16px;
  color: #0066cc;
  text-decoration: none;
  font-weight: bold;
`;
